<script>
// @ts-check

import { api } from '@/api/'
import AppToastContainer from '@/components/utils/AppToastContainer.vue'
import DialogManager from '@/components/utils/DialogManager.vue'
import { postNativeMessage } from '@/helpers/mobile'
import { ROUTE_LAYOUT } from '@/router/meta'
import { useLanguageStore } from '@/store/language'
import { useSharedStore } from '@/store/shared'
import BaseView from '@/views/BaseView.vue'
import { mapState } from 'pinia'
import { computed, provide } from 'vue'
import { RouterView } from 'vue-router'
import { mapActions, useStore } from 'vuex'

export default {
  name: 'App',
  components: {
    AppToastContainer,
    DialogManager,
    RouterView
  },
  setup() {
    const store = useStore()
    const sharedStore = useSharedStore()

    provide(
      'isMobileApp',
      computed(() => store.getters['mobileData/isMobileWrapperUser'])
    )
    provide(
      'isAndroid',
      computed(() => store.getters['mobileData/isAndroid'])
    )
    provide(
      'isIos',
      computed(() => store.getters['mobileData/isIos'])
    )
    provide(
      'service',
      computed(() => store.state.app.service)
    )
    provide(
      'isMobileAppAndIos',
      computed(() => store.getters['mobileData/isMobileAppAndIos'])
    )

    // Synchronize state to mobile app.
    sharedStore.$subscribe((mutation, state) => {
      postNativeMessage(
        JSON.stringify({
          type: 'state_change',
          message: state
        })
      )
    })

    // Synchronize state from mobile app.
    window.addEventListener('message', (message) => {
      if (message.data?.type !== 'state_change' || !message.data?.state) {
        return
      }

      sharedStore.$patch(message.data.state)
    })
  },
  computed: {
    ...mapState(useLanguageStore, ['language']),
    layout() {
      if (this.$route.meta && this.$route.meta[ROUTE_LAYOUT]) {
        return this.$route.meta[ROUTE_LAYOUT]
      }

      return BaseView
    }
  },
  watch: {
    language(currentLanguage) {
      document.documentElement.lang = currentLanguage
    }
  },
  created() {
    this.setAllowedExternalUrls()
    this.$i18n.locale = this.language
    document.documentElement.lang = this.language
  },
  mounted() {
    // Zendesk chat widget authentication
    const authStore = this.$store.state.auth

    window.zendeskFn = (/** @type {Function} */ callback) => {
      if (authStore.accessToken) {
        api.get('user/zendesk-token').then((response) => callback(response))
      }
    }

    // Check if user is using mobile application
    this.checkMobileStatus()
  },
  methods: {
    ...mapActions('mobileData', ['checkMobileStatus', 'setAllowedExternalUrls'])
  }
}
</script>

<template>
  <component :is="layout">
    <DialogManager />
    <template #containers>
      <AppToastContainer />
    </template>
    <RouterView />
  </component>
</template>
